var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_waiting-for-keys") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.87,20.79C19.6,18,18.14,17.52,18.14,16s1.46-2,4.74-4.79,2.49-7.56,2.49-7.56H6.64S5.85,8.42,9.13,11.21s4.74,3.27,4.74,4.79-1.46,2-4.74,4.79-2.49,7.56-2.49,7.56H25.36S26.15,23.58,22.87,20.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.19,
    y: 28.37,
    width: 23.62,
    height: 3.63,
    rx: 1.82,
    ry: 1.82,
    fill: "#8f4d38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.19,
    width: 23.62,
    height: 3.63,
    rx: 1.82,
    ry: 1.82,
    fill: "#8f4d38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66,25.43A4.41,4.41,0,0,1,11,23c0.91-.78,1.66-1.35,2.32-1.86a12.81,12.81,0,0,0,2.44-2.23h0.42a12.81,12.81,0,0,0,2.44,2.23C19.31,21.64,20.06,22.22,21,23a4.4,4.4,0,0,1,1.37,2.43H9.66Z",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.21,8A3.78,3.78,0,0,0,11,9c0.91,0.78,1.66,1.35,2.32,1.86a12.81,12.81,0,0,1,2.44,2.23h0.42a12.81,12.81,0,0,1,2.44-2.23C19.31,10.36,20.06,9.78,21,9a3.79,3.79,0,0,0,.82-1H10.21Z",
    fill: "#ef5350"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.87,20.79C19.6,18,18.14,17.52,18.14,16s1.46-2,4.74-4.79,2.49-7.56,2.49-7.56H16V28.35h9.36S26.15,23.58,22.87,20.79Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,0H16V3.63H26A1.82,1.82,0,0,0,26,0Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,28.37H16V32H26A1.82,1.82,0,0,0,26,28.37Z",
    opacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestPending);
export default __webpack_public_path__ + "static/media/request_pending.4281a005b89ea5c2bae68e1f1bd3f1e1.svg";
export { ForwardRef as ReactComponent };